import React from "react";
import { FiMail, FiLinkedin } from "react-icons/fi";
import "./PageFooter.scss";
import { Link } from "react-router-dom";

import { Container, Row, Col } from "react-bootstrap";
function PageFooter() {
  return (
    <footer className="froi-footer">
      <Container className="froi-footer__container">
        <Row className="row">
          {/* Logo / Brand */}
          <Col lg={5} md={5} xs={12}>
            <div className="froi-footer__brand">
              <Link to={"/"}>
                <img
                  src="./images/Footer/compact_logo_footer.png"
                  alt="FROI"
                  className="froi-footer__logo"
                />
              </Link>

              <img
                src="./images/Footer/Footer_Tag_Line.png"
                alt="FROI_TagLine"
                className="froi-footer__Tagline"
              />
            </div>
          </Col>
          {/* Social */}
          <Col lg={2} md={2} xs={12}>
            <div className="froi-footer__social">
              <a
                href="https://www.linkedin.com/company/froi-future-ready-organization-institute®/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <FiLinkedin />
              </a>

              <Link to="/contact">
                <FiMail />
              </Link>
            </div>
          </Col>
          {/* Navigation */}
          <Col lg={5} md={5} xs={12}>
            <div className="froi-footer__links page_links">
              <div className="froi-footer__column">
                <a href="/">Home</a>
                <a href="/froi-about">About</a>
                <a href="/froi-accreditation">Accreditation</a>
                <a href="/froi-certification">Certification™</a>
              </div>

              <div className="froi-footer__column">
                <a href="/froi-global-index">Global Index</a>
                <a href="/froi-model">FROI’s Model</a>
                {/* <a href="/froi-center">FROI’s Center</a> */}
                <a href="/contact">Get in touch</a>
              </div>
            </div>
          </Col>
        </Row>

        {/* Divider */}
        <div className="froi-footer__divider" />

        {/* Copyright */}
        <div className="froi-footer__copyright">
          © 2026 FROI. All rights reserved.
        </div>
      </Container>
    </footer>
  );
}

export default PageFooter;
